<template>
  <div class="mask" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <div class="filter">
          <p class="title">关联选题</p>
          <div class="selectInputer">
            <div class="keyword">
              <span @click="toggleOption()">{{selected.title || '主题'}}</span>
              <div v-if="expand" class="selects">
                <span v-for="(o, i) in options" :key="i" class="option" @click="selectOption(o)">
                  {{o.title}}
                </span>
              </div>
            </div>
            <img :src="expand ? icons.up : icons.down" alt="direct" class="direct" @click="toggleOption()">
            <input class="enter" type="text" placeholder="请输入要查找的选题" v-model="search.word" @keyup.enter="searchByWord()">
            <img src="../assets/img/interview/search.svg" alt="search" class="search" @click="searchByWord()">
          </div>
          <date-picker class="topicDateSelect" :type="'date'" :format="'YYYY-MM-DD'" v-model="datePicker" placeholder="选择时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
        </div>
        <img src="../assets/img/interview/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="container" ref="container">
        <empty :msg="'暂无选题数据'" v-if="list && list.length === 0" />
        <div :class="{content: true, selected: selectedItem.id === l.id}" v-for="(l, i) in list" :key="i" @click="selectItem(l)">
          <div class="item">
            <span class="name">{{l.title}}</span>
            <span class="depart">{{l.user_name}}</span>
            <span class="depart">{{l.depart_name}}</span>
            <span class="time">{{l.raw_add_time}}</span>
          </div>
        </div>
      </div>
      <div class="footline">
        <div class="btn" @click="confirm()">
          关联
        </div>
        <div class="btn gray" @click="close()">
          取消
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'withTopic',
  components: {
    empty,
    DatePicker
  },
  props: {
    // getTopic: {
    //   type: Function,
    //   required: true
    // }
    from: { // 来自模块
      type: Number,
      default: 1 // 1: 采访，2: 线索， 3: 报道，4: 发布
    }
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n) {
        this.nowDate = this.stampToTime(this.datePicker)
        this.page.pageIndex = 1
        this.getList()
      }
    }
  },
  data() {
    return {
      nowDate: '',
      datePicker: '',
      show: false,
      icons: {
        up: require('../assets/img/interview/up.png'),
        down: require('../assets/img/interview/down.png')
      },
      options: [],
      search: {
        key: '',
        word: ''
      },
      list: null,
      selected: {},
      selectedItem: {},
      expand: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: null
      },
      scrollLock: false
    }
  },
  methods: {
    getToday() {
      // 获取当日时间戳
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const day = today.getDate()
      const startSec = new Date(`${year}-${month}-${day}`)

      return startSec
    },
    initDate() {
      // 默认选中当日时间
      const today = this.getToday()
      this.datePicker = today
    },
    doubleDigit(n) {
      // 将数字转为两位，不足补零
      if (n / 10 < 1) {
        return `0${n}`;
      }

      return `${n}`;
    },
    stampToTime(s) {
      // 将时间戳转换为时间
      if (!s) {
        return "";
      }

      const year = s.getFullYear();
      const month = this.doubleDigit(s.getMonth() + 1);
      const day = this.doubleDigit(s.getDate());

      return `${year}-${month}-${day}`;
    },
    toggleOption() {
      this.expand = !this.expand
    },
    selectOption(o) {
      this.selected = o
      this.search.key = o.key
      this.expand = false
    },
    close() {
      this.show = false
    },
    open() {
      this.show = true
      this.initDate()
      this.$nextTick(() => {
        // this.getList()
        this.handleScroll()
      })
    },
    getList() {
      let url = ''
      if (this.from === 1) {
        url = apis.Itv_topics
      } else if (this.from === 2) {
        url = apis.clue_topics
      } else if (this.from === 3) {
        url = apis.Rpt_topics
      } else if (this.from === 4) {
        url = apis.publish_withTopic
      }

      this.scrollLock = true
      if (this.page.totalPage && this.page.pageIndex > this.page.totalPage) return

      const info = {
        search_option: this.search.key,
        key_words: this.search.word,
        create_time: '',
        tags: '',
        date: this.nowDate,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      if(this.page.pageIndex == 1){
        this.list = []
      }

      common.myFetch(url, info)
      .then((data) => {
        this.page.pageIndex += 1
        this.list = (this.list || []).concat(data.list)
        this.options = data.params.top_search.option.list
        this.selectDefault(this.options)
        this.page.totalPage = data.page.page_count
        this.scrollLock = false
      })
    },
    searchByWord() {
      // 输入搜索关键字后搜索
      this.page.pageIndex = 1
      this.list = []
      this.getList()
    },
    selectDefault(l) {
      // 默认选中选项
      l.forEach((o) => {
        if (o.selected) {
          this.selected = o
          this.search.key = o.key
        }
      })
    },
    confirm() {
      // 回传
      const item = this.selectedItem
      if (!item.id) {
        this.$toast('请选择策划')
        return
      }

      this.$emit('getTopic', item)
      this.close()
    },
    selectItem(l) {
      this.selectedItem = l
    },
    handleScroll() {
      const container = this.$refs.container
      container.addEventListener('scroll', () => {
        const scrolltop = container.scrollTop;
        const scrollheight = container.scrollHeight;
        const clientheight = container.clientHeight;

        if (scrolltop + clientheight >= scrollheight) {
          if (this.scrollLock) return
          this.getList()
        }
      }, false)
    }
  },
  mounted() {
    // this.getList()
    // this.handleScroll()
  }
}
</script>

<style lang="less">
.topicDateSelect {
  width: 240px !important;
  min-width: 240px !important;
  height: 40px;
  border-radius: 100px;
  background: rgba(185, 195, 195, 0.2);
  border: none;
  margin-left: 20px;

  .mx-input {
    width: 240px !important;
    min-width: 240px !important;
    height: 40px !important;
    line-height: 40px !important;
    border: none !important;
  }

  .mx-clear-wrapper {
    background-color: #ECEEEE !important;
  }

  .mx-input-icon {
    background: transparent;
  }
}
</style>

<style lang="less" scoped>
  @import '../assets/css/global.less';
  
  .mask {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: fixed;
    z-index: 1111;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    .wrapper {
      .boxOuter;
      width: 880px;
      height: 550px;
      display: flex;
      flex-direction: column;
      .headline {
        height: 70px;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .filter {
          height: 70px;
          display: flex;
          align-items: center;
          .title {
            font-size: 24px;
            color: @dark;
            font-weight: bold;
          }
          .selectInputer {
            width: 300px;
            height: 40px;
            border-radius: 100px;
            background:rgba(185, 195, 195, 0.20);
            margin-left: 30px;
            padding: 0 20px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            .keyword {
              color: @sub;
              font-size: 14px;
              cursor: pointer;
              min-width: 42px;
              .selects {
                background-color: @dark;
                background-color: rgba(5, 15, 15, 0.8);
                position: absolute;
                width: 90px;
                border-radius: 4px;
                display: flex;
                flex-direction: column;
                padding: 10px 0;
                margin: 20px 0 0 -20px;
                .option {
                  color: #fff;
                  height: 30px;
                  line-height: 30px;
                  cursor: pointer;
                  padding-left: 20px;
                  &:hover {
                    background-color: @green;
                  }
                }
              }
            }
            .direct {
              margin: 0 10px 0 10px;
              cursor: pointer;
            }
            .enter {
              flex: 1;
              color: @dark;
              font-size: 14px;
              background-color: transparent;
              &::placeholder {
                color: @dateColor;
                font-size: 14px;
              }
            }
            .search {
              margin-left: 10px;
              margin-right: 10px;
              cursor: pointer;
            }
          }
        }
        .close {
          cursor: pointer;
        }
      }
      .container {
        flex: 1;
        overflow-y: auto;
        .content {
          padding: 0 30px;
          cursor: pointer;
          &:hover {
            background-color: rgba(185,195,195,0.15);
          }
          .item {
            height: 60px;
            border-bottom: 1px solid #dcdcdc;
            display: flex;
            align-items: center;
            .name {
              flex: 1;
              font-size: 16px;
              color: @dark;
            }
            .publiser {
              width: 188px;
              font-size: 14px;
              color: @dark;
              text-align: center;
            }
            .depart {
              width: 130px;
              font-size: 14px;
              color: @dark;
              text-align: center;
            }
            .time {
              .numberFont;
              width: 130px;
              font-size: 14px;
              color: @dateColor;
              text-align: right;
            }
          }
        }
        .content:last-child {
          .item {
            border: none;
          }
        }
        .selected {
          background-color: rgba(65,180,140,0.15) !important;
          span {
            color: @green !important;
            font-weight: bold;
          }
        }
      }
      .footline {
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn {
          width: 120px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 100px;
          background-color: @green;
          color: #fff;
          font-size: 14px;
          margin-right: 20px;
          cursor: pointer;
          &:active {
            .btnActive;
          }
          &:hover {
            .btnHover;
          }
        }
        .gray {
          margin-right: 0;
          background-color: @dateColor;
        }
      }
    }
  }
</style>
